<span class="zef-text-p3 zef-color-vibrant">
  {{ flag }}
</span>
